import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import useToggle from "../../../hooks/useToggle";
import GeneralInfoCard from "../generalInfo/GeneralInfoCard";
import SectionCardHeader from "../SectionCardHeader";
import DamageFormService from "../service/DamageFormService";
import { DamageFormTypes } from "../Types";
import Dialogs from "./dialogs";
import { ContextDamageForm } from "../DamageFormContext";
import EmptyState from "../../../../../util/component/EmptyState";
import { useHasScope } from "../../../../../config/globalConfig";

const Messages = () => {
  const hasScope = useHasScope;

  const { setLoading } = useContext(ContextOperation);
  const damageFormContext = useContext(ContextDamageForm);

  const t = useOperationTranslation();

  const { id } = useParams();

  const [openNewMessage, toggleNewMessage] = useToggle();

  const [messages, setMessages] = useState<DamageFormTypes.IMessage[]>([]);

  const getMessages = () => {
    if (!id) return;

    setLoading(true);
    DamageFormService.details.messages.get.byId(id).then(
      (response) => {
        setLoading(false);
        setMessages(response);
      },
      (error) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (openNewMessage) return;

    getMessages();
  }, [openNewMessage]);

  return (
    <>
      <Mui.Box mt={2}>
        <Mui.Card>
          <SectionCardHeader>
            <Mui.Grid container spacing={2} mr={1}>
              {!damageFormContext.generalInfo?.migrated &&
                hasScope("SCOPE_CREATE_DAMAGE_MAIL") && (
                  <Mui.Grid item xs="auto">
                    <Mui.Button
                      variant="outlined"
                      size="small"
                      startIcon={<MuiIcons.Email />}
                      onClick={toggleNewMessage}
                    >
                      <Mui.Typography color="inherit" variant="h6">
                        {t("damageForm.details.messages.header.btnNewMessage")}
                      </Mui.Typography>
                    </Mui.Button>
                  </Mui.Grid>
                )}
            </Mui.Grid>
          </SectionCardHeader>

          <Mui.CardContent>
            <Mui.Stack spacing={2}>
              <GeneralInfoCard />

              {messages.map((element) => {
                return (
                  <Mui.Card>
                    <Mui.CardContent>
                      <Mui.Typography textAlign="end" variant="h6">
                        {dayjs(element.sendDate).format("DD/MM/YYYY HH:mm")}
                      </Mui.Typography>

                      <Mui.Grid container alignItems="center" spacing={1}>
                        <Mui.Grid item xs="auto" sm={2} md={1}>
                          <Mui.Typography>
                            {t("damageForm.details.messages.mail.labels.to")}
                          </Mui.Typography>
                        </Mui.Grid>
                        <Mui.Grid item xs={10} sm={10} md={11}>
                          <Mui.Typography variant="h6">
                            {element.to}
                          </Mui.Typography>
                        </Mui.Grid>
                      </Mui.Grid>

                      <Mui.Grid container alignItems="center" spacing={1}>
                        <Mui.Grid item xs="auto" sm={2} md={1}>
                          <Mui.Typography>
                            {t(
                              "damageForm.details.messages.mail.labels.subject"
                            )}
                          </Mui.Typography>
                        </Mui.Grid>
                        <Mui.Grid item xs={9} sm={10} md={11}>
                          <Mui.Typography
                            variant="h6"
                            flexWrap="wrap"
                            whiteSpace="break-spaces"
                          >
                            {element.subject}
                          </Mui.Typography>
                        </Mui.Grid>
                      </Mui.Grid>

                      <Mui.Typography variant="body1" color={"gray"}>
                        {element.body}
                      </Mui.Typography>
                    </Mui.CardContent>
                  </Mui.Card>
                );
              })}
            </Mui.Stack>
          </Mui.CardContent>
        </Mui.Card>

        {messages.length === 0 ? (
          <Mui.Box mt={3}>
            <EmptyState
              title={t("damageForm.details.messages.emptyState.title")}
              content={t("damageForm.details.messages.emptyState.content1")}
            />
            <EmptyState
              title=""
              content={t("damageForm.details.messages.emptyState.content2")}
            />
            <EmptyState
              title=""
              content={t("damageForm.details.messages.emptyState.content3")}
            />
          </Mui.Box>
        ) : null}
      </Mui.Box>

      <Dialogs.NewMessages open={openNewMessage} onClose={toggleNewMessage} />
    </>
  );
};
export default Messages;
